import React, { createContext, useContext, useEffect, useState, Dispatch, SetStateAction } from 'react';


export interface VendorContextType {
  vendor: Vendor | null;
  setVendor: Dispatch<SetStateAction<Vendor | null>>;
}

const VendorContext = createContext<VendorContextType | undefined>(undefined);

export const useVendorType = (): VendorContextType => {
  const context = useContext(VendorContext);
  if (!context) {
    throw new Error('useVendorType must be used within an VendorProvider');
  }
  return context;
};

interface VendorProviderProps {
  children: React.ReactNode;
}

export const VendorProvider: React.FC<VendorProviderProps> = ({ children }) => {
  const [vendor, setVendor] = useState<Vendor | null>(() => {
    // Retrieve the vendor from localStorage when the component mounts
    const storedVendor = localStorage.getItem('vendor');
    return storedVendor ? JSON.parse(storedVendor) : null;
  });



  useEffect(() => {
    if (vendor) {
      console.log("Vendor was set", vendor);
      // Save the vendor data in localStorage whenever it changes
      localStorage.setItem('vendor', JSON.stringify(vendor));
    } else {
      // Remove from localStorage if vendor is null (e.g., logout)
      localStorage.removeItem('vendor');
    }
  }, [vendor]);





  const contextValue: VendorContextType = {
    vendor,
    setVendor
  };

  return (
    <VendorContext.Provider value={contextValue}>
      {children}
    </VendorContext.Provider>
  );
};
